<template>
    <v-row dense>
        <v-col cols="12">
            <v-sheet class="transactionTable pb-0" :class="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'
                ">
                <div class="title-bar">
                    <div class="d-flex align-center">
                        <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
                        <v-card-title class="pa-0">IB Commission In</v-card-title>
                    </div>
                    <v-spacer></v-spacer>
                    <router-link class="links pr-0" to="/transaction-history">See All Transactions
                        ></router-link>
                </div>
                <v-data-table :headers="headers" :items="partner_summary?.latestCommissions" hide-default-footer>
                </v-data-table>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import { DASHBOARD__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            headers: [
                { text: "Sl", value: "sl" },
                // { text: "Update Time", value: "updated_at" },
                { text: "Client", value: "name" },
                { text: "Acc No", value: "account_no" },
                { text: "Position", value: "position_id" },
                { text: "Close Time", value: "to_date" },
                { text: "Lot", value: "volume" },
                { text: "Symbol", value: "symbol" },
                { text: "Acc Type", value: "account_type" },
                { text: "Level", value: "level" },
                { text: "Commission ($)", value: "commission" },
            ],
        };
    },
    computed: {
        ...mapState("dashboard", ["partner_summary"]),
    },

    methods: {
        ...mapActions("dashboard", [DASHBOARD__ACTIONS.PARTNERSUMMARY]),
    },
    async mounted() {
        try {
            await this[DASHBOARD__ACTIONS.PARTNERSUMMARY];
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
